/// <amd-module name="Build/Admin/Common/Stores/ServiceEndpointStore" />
import { Store } from "VSS/Reflux/Store";

import { AzureSubscription, ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

import { StoreStatus } from "Build/Admin/Common/Constants";

export interface IServiceEndpointStoreState {
    azureSubscriptions: AzureSubscription[];
    azureSubscriptionsStatus: StoreStatus;
    serviceEndpointScope: string;
    serviceEndpoints: ServiceEndpoint[];
    serviceEndpointsStatus: StoreStatus;
}

export class ServiceEndpointStore extends Store {
    public state: IServiceEndpointStoreState = {
        azureSubscriptions: [],
        azureSubscriptionsStatus: StoreStatus.None,
        serviceEndpointScope: "",
        serviceEndpoints: [],
        serviceEndpointsStatus: StoreStatus.None,
    };

    constructor() {
        super("ServiceEndpointStoreChanged");
    }

    public updateAzureSubscriptions = (azureSubscriptions: AzureSubscription[]): void => {
        this.state = {
            ...this.state,
            azureSubscriptions: azureSubscriptions.slice(0),
            azureSubscriptionsStatus: StoreStatus.Loaded
        };

        this.emitChanged();
    }

    public updateAzureSubscriptionsStatus = (azureSubscriptionsStatus: StoreStatus): void => {
        this.state = {
            ...this.state,
            azureSubscriptionsStatus
        };

        this.emitChanged();
    }

    public updateServiceEndpoints = (serviceEndpointScope: string, serviceEndpoints: ServiceEndpoint[]): void => {
        this.state = {
            ...this.state,
            serviceEndpointScope: serviceEndpointScope.slice(0),
            serviceEndpoints: serviceEndpoints.slice(0),
            serviceEndpointsStatus: StoreStatus.Loaded
        };

        this.emitChanged();
    }

    public updateServiceEndpointStatus = (serviceEndpointsStatus: StoreStatus): void => {
        this.state = {
            ...this.state,
            serviceEndpointsStatus
        };

        this.emitChanged();
    }

    public serviceEndpointAuthorized = (serviceEndpoint: ServiceEndpoint): void => {
        // If an existing service endpoint with this ID exists, filter it out
        const serviceEndpoints: ServiceEndpoint[] = this.state.serviceEndpoints.filter(endpoint => endpoint.id !== serviceEndpoint.id);

        // Now add the endpoint to the new object
        serviceEndpoints.push(serviceEndpoint);

        this.state = {
            ...this.state,
            serviceEndpoints
        };
        this.emitChanged();
    }
}
